import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  formatCurrency,
  formatNumber,
  ANALYTICS_COLORS,
  trendDirectionColorKey,
} from "./analyticsFormat";

// 0024/0025: 6-month trend. Bars = orders (neutral blue, left axis). Revenue line (right axis)
// is colored SEMANTICALLY by direction — green if last month > previous, red if lower, amber if
// flat/insufficient. XAxis reversed so the timeline reads right-to-left (Hebrew/RTL).
const TrendChart = ({ data }) => {
  const lineColor = ANALYTICS_COLORS[trendDirectionColorKey(data)];

  return (
    <div className="analyticsChartCard">
      <h3 className="analyticsCardTitle">מגמת הזמנות ומחזור (6 חודשים)</h3>
      <p className="analyticsCardCaption">צבע קו המחזור לפי המגמה מול החודש הקודם: ירוק = עלייה, אדום = ירידה, כתום = ללא שינוי</p>
      <ResponsiveContainer width="100%" height={360}>
        <ComposedChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef0f3" />
          <XAxis dataKey="label" reversed tick={{ fontSize: 12 }} />
          <YAxis yAxisId="orders" orientation="right" allowDecimals={false} tick={{ fontSize: 12 }} />
          <YAxis
            yAxisId="revenue"
            orientation="left"
            tick={{ fontSize: 12 }}
            tickFormatter={(v) => formatNumber(v)}
          />
          <Tooltip
            formatter={(value, name) =>
              name === "מחזור (₪, לפני מע״מ)"
                ? formatCurrency(value)
                : formatNumber(value)
            }
          />
          <Legend />
          <Bar yAxisId="orders" dataKey="orders" name="הזמנות" fill={ANALYTICS_COLORS.blue} fillOpacity={0.35} radius={[4, 4, 0, 0]} />
          <Line
            yAxisId="revenue"
            type="monotone"
            dataKey="revenue"
            name="מחזור (₪, לפני מע״מ)"
            stroke={lineColor}
            strokeWidth={3}
            dot={{ r: 4, fill: lineColor }}
            activeDot={{ r: 6 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendChart;
